const TmpPE024 = (page) => {

  const modifiedPage = {
    ...page
  };

  const images = [];
  const media = [];

  // Inject page.id into each focus point if present
  if (Array.isArray(page.focusPointsData)) {
    page.focusPointsData.forEach((fp) => {
      fp.page = page.id;
    });
  }

  const pptImage = {
    size: '960px X 540px',
    ...page.content.media,
    id: page.id + '-ppt',
    page: page.id,
    src: page.label.toLowerCase().replaceAll('-', '_') + '.jpg'
  };

  // Add the PPT image to the media and images arrays
  media.push(pptImage);
  images.push(pptImage);

  modifiedPage.content.media = pptImage;
  modifiedPage.title = 'Constructed Presentation Brief';

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE024;
